// src/prototype/components/StepList.tsx
// Numbered orange-dot step list — the Immediate Next Steps section of the Decision Brief.
import React from 'react';

export interface StepListProps {
  steps: string[];
}

export const StepList: React.FC<StepListProps> = ({ steps }) => (
  <ol className="space-y-2.5">
    {steps.map((step, i) => (
      <li key={step} className="flex items-start gap-2.5">
        <span className="w-5 h-5 rounded-full bg-[#FF6E4C] text-white text-[10px] font-bold flex items-center justify-center shrink-0 mt-0.5">
          {i + 1}
        </span>
        <span className="text-sm text-[#4b5563] leading-relaxed">{step}</span>
      </li>
    ))}
  </ol>
);

export default StepList;
